import { gql } from '@apollo/client';

export const CREATE_AUXILIARY_ASSIGNMENT = gql`
	mutation createAuxiliaryAssignment(
		$newAssignment: WorkAssignmentAuxiliaryCreationInput!
		$overlappingActivityAction: OverlappingActivityAction
		$delayMinutes: Int
	) {
		saveAuxiliaryWorkAssignment(
			input: $newAssignment
			overlappingActivityAction: $overlappingActivityAction
			delayMinutes: $delayMinutes
		) {
			... on WorkAssignmentAuxiliaryMutationSuccessResponse {
				workAssignment {
					id
					version
					fromTimestamp
					fromStation {
						id
						name
					}
					toStation {
						id
						name
					}
					crewMember {
						id
						fullName
					}
				}
			}
			... on WorkAssignmentAuxiliaryMutationErrorResponse {
				errors
				__typename
			}
			__typename
			... on WorkAssignmentOverlappingActivitiesResponse {
				overlappingActivities {
					fromTimestamp
					toTimestamp
					isCancellable
					activity {
						... on CrewMemberWorkAssignmentActivityItem {
							activityType
							fromStation {
								name
								code
								timezone
								city {
									name
								}
							}
							toStation {
								name
								code
								timezone
								city {
									name
								}
							}
						}
						... on CrewMemberAbsenceActivityItem {
							note
							reason {
								id
								name
							}
						}
					}
				}
				minDelayMinutes
				maxDelayMinutes
			}
		}
	}
`;
